/**
 * SearchBar Component
 * Provides search functionality for filtering permissions
 */

import React from 'react';
import { Tooltip } from 'antd';

const SearchBar = ({ value, onChange, onClear, onAddRole, canCreate = false }) => {
  const buttonContent = (
    <button 
      className={`rp-add-role-btn ${!canCreate ? 'disabled' : ''}`}
      onClick={canCreate ? onAddRole : undefined}
      disabled={!canCreate}
    >
      <i className="bi bi-plus-lg"></i>
      Add Role
    </button>
  );

  return (
    <div className="rp-controls">
      {/* Search input */}
      <div className="rp-search-wrapper">
        <i className="bi bi-search search-icon"></i>
        <input
          type="text"
          className="rp-search-input"
          placeholder="Search permissions..."
          value={value}
          onChange={onChange}
        />
        {value && (
          <i 
            className="bi bi-x-circle search-clear"
            onClick={onClear}
          ></i>
        )}
      </div>
      
      {/* Add role button with tooltip when disabled */}
      {canCreate ? (
        buttonContent
      ) : (
        <Tooltip 
          title="You don't have permission to create roles"
          placement="left"
        >
          {buttonContent}
        </Tooltip>
      )}
    </div>
  );
};

export default SearchBar;

